var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"u-size-14 u-italic hint"},[_c('i',{class:`el-icon-${_vm.icon} mr-4`,attrs:{"aria-hidden":"true"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }